import { render, staticRenderFns } from "./property-setting-view-page.vue?vue&type=template&id=cff1dd42&"
import script from "./property-setting-view-page.vue?vue&type=script&lang=js&"
export * from "./property-setting-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports